import React, { useRef } from "react";
import github from "/home/lunar/documents/betterps/src/components/images/github-mark-white.png";
import emailjs from '@emailjs/browser';
import './ContactMe.css'

const ContactMe = () => {
    const form = useRef();
    
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_kahapff', 'template_tu9xjjg', form.current, 'jNC1jy0yXtDqwUH-b')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    };

    return (
        <div id="contact">
            <footer>
                <h1 id="title-contactme">Contact Me</h1>
                <div id="contact-me-container">
                <form id="email-me" ref={form} onSubmit={sendEmail}>
                    <input type="text" placeholder="Full Name" name="user_name" required/>
                    <input type="email" placeholder="Email" name="user_email" required/>
                    <input type="text" placeholder="Subject" name="subject" required/>
                    <textarea name="message" cols="30" rows="10"></textarea>
                    <button type="submit">Send</button>
                </form>
                <div id="links">
                <a href="https://github.com/xLunar11x">
                    <img id="github" src={github} alt="github-anthony" />
                </a>
                <a href="https://www.linkedin.com/in/anthony-penaloza-05b672266/">
                    <img alt="linkedIn-anthony" src="https://media.licdn.com/dms/image/C560BAQHaVYd13rRz3A/company-logo_200_200/0/1638831589865?e=2147483647&v=beta&t=Zq1zixRFUNMSm2Ldgu_hcJAYTL1gWG3VHKXO4kf9lDQ"/>
                </a>
                </div>
                </div>
            </footer>
        </div>
    )
}

export default ContactMe;